import { render, staticRenderFns } from "./AdminContactsAssignView.vue?vue&type=template&id=4da0f5a0"
import script from "./AdminContactsAssignView.vue?vue&type=script&lang=js"
export * from "./AdminContactsAssignView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports